import Container from '@components/ui/container';
import AccountNav from '@components/my-account/account-nav';
import { ROUTES } from '@utils/routes';
import SettingsIcon from '@components/icons/account-settings';
import OrdersIcon from '@components/icons/account-order';
import MapIcon from '@components/icons/account-address';
import AccountNavMobile from '@components/my-account/account-nav-mobile';
import { useRouteLang } from 'src/hooks/use-route-lang';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '@contexts/use-auth-context';

const accountMenu = [
  {
    slug: ROUTES.ACCOUNT_SETTING,
    name: 'account-settings',
    icon: <SettingsIcon className="w-5 md:w-[22px] h-5 md:h-[22px]" />,
  },
  {
    slug: ROUTES.ACCOUNT_ORDERS,
    name: 'text-orders',
    icon: <OrdersIcon className="w-5 md:w-[22px] h-5 md:h-[22px]" />,
  },
  {
    slug: ROUTES.ADDRESS,
    name: 'text-address',
    icon: <MapIcon className="w-5 md:w-[22px] h-5 md:h-[22px]" />,
  },
];

export default function AccountLayout() {
  const { isAuthenticated } = useAuthContext();
  const lang = useRouteLang();

  if (!isAuthenticated) {
    return <Navigate to={`/${lang}`} replace={true} />;
  }

  return (
    <div className="border-t border-b border-border-base">
      <Container>
        <div className="pt-10 2xl:pt-12 pb-12 lg:pb-14 xl:pb-16 2xl:pb-20 xl:max-w-screen-xl 2xl:max-w-[1300px] mx-auto">
          <div className="flex flex-col w-full lg:flex-row">
            <div className="lg:hidden">
              <AccountNavMobile options={accountMenu} lang={lang} />
            </div>
            <div className="hidden lg:block shrink-0 w-56 xl:w-72 2xl:w-[385px] ltr:mr-7 rtl:ml-7 xl:ltr:mr-8 xl:rtl:ml-8">
              <AccountNav options={accountMenu} lang={lang} />
            </div>

            <div className="w-full p-4 mt-4 overflow-x-auto border rounded-md lg:mt-0 border-border-base sm:p-5 lg:py-8 2xl:py-10 lg:px-7 2xl:px-12">
              <Outlet />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
